import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import AddAlertBelowThresholdContent from "components/pages/AdvancedAlertsPage/components/AddAlertBelowThresholdContent";
import Classes, { Account } from "model";

export default function CaptureNotifiLegacyBalanceBelowThresholdAmount(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    const dataObj = { id: account.id, selectedUserAccountID: "1", selectedUserAccountType: "email", amount: "100.00" };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], AddAlertBelowThresholdContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}